import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconApplicationStatusNtpLocation.tsx
const IconApplicationStatusNtpLocation = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M14.124 9.958a5.83 5.83 0 0 0 1.549-5.485l2.079-.89a.417.417 0 0 1 .58.382v11.868l-5.833 2.5-5-2.5-5.252 2.251a.417.417 0 0 1-.581-.383V5.833l2.607-1.117a5.83 5.83 0 0 0 1.602 5.242l4.124 4.125z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "m10 11.726 2.947-2.947a4.166 4.166 0 1 0-5.893 0z"
		})
	]
});
var IconApplicationStatusNtpLocation_default = forwardRef(IconApplicationStatusNtpLocation);
//#endregion
export { IconApplicationStatusNtpLocation_default as default };
